import {Box, Text, UseModalProps} from '@chakra-ui/react';
import {AlertDialog} from 'components/shared';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {TranslationKeys} from 'translations';

import {ProviderTypeEnum} from '../../../../types';

export interface IModalProps extends UseModalProps {
  name: string;
  t: (term: TranslationKeys) => string;
  providerType?: ProviderTypeEnum;
  message?: string;
  onConfirm?: () => void;
}

export const PauseProviderBanner: FC<IModalProps> = ({name, isOpen, onClose, t, providerType, message, onConfirm}) => {
  const {push} = useRouter();

  const handleConfirm = () => {
    push(`/${providerType}s`);
  };

  const messageText = (message || t('PAUSE_PROVIDER_DESCRIPTION')).replace(
    '%providerName%',
    `<strong>${name}</strong>`,
  );

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm ?? handleConfirm}
      successButtonValue={t('OPEN_PROVIDER')}
      cancelButtonValue={t('CONTINUE_HERE')}
    >
      <Box w="100%" textAlign="justify">
        <Text
          whiteSpace="pre-line"
          fontWeight="500"
          dangerouslySetInnerHTML={{
            __html: messageText,
          }}
        />
      </Box>
    </AlertDialog>
  );
};
